<template>
  <div class="Kontrow-Principal">
    <PageTitle
      icon="fa fa-bullhorn"
      main="Globus convocação"
      sub="Monitoramento"
    />
    <div class="Kontrow-Principal">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Convocação" active><GlobusConvocacao /></b-tab>
          <b-tab title="Monitorar notificações de Convocações"
            ><GlobusConvocacaoNotificacoes
          /></b-tab>
          <!--       <b-tab title="Indicadores"><GlobusConvocacaoPainel /></b-tab>             -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import GlobusConvocacao from "../treinamento/GlobusConvocacao";
import GlobusConvocacaoNotificacoes from "../treinamento/GlobusConvocacaoNotificacoes";
//import GlobusConvocacaoPainel from "../treinamento/GlobusConvocacaoPainel";
export default {
  name: "GlobusConvocacaoPrincipal",
  components: { PageTitle, GlobusConvocacao, GlobusConvocacaoNotificacoes },
};
</script>

<style>
</style>






